import { render, staticRenderFns } from "./ShippingsTable.vue?vue&type=template&id=491fbec8"
import script from "./ShippingsTable.vue?vue&type=script&lang=js"
export * from "./ShippingsTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingsTable.vue?vue&type=style&index=0&id=491fbec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports